module.exports = __webpack_public_path__ + "img/parkStyleSwiper1.0e6c319f.png";